import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { FilterFormContainerProps } from "models/propTypes/filterPropTypes";
import { FormikProps } from "formik";
//#endregion
//#region components
import FilterForm from "./filterForm";
//#endregion

const FilterFormContainer: ForwardRefRenderFunction<FormHandles, FilterFormContainerProps> = (props, ref) => {
  const { filter } = props;

  const onQuickSelectionChange = (name: string, selectedFilterId: any, formikProps: FormikProps<any>) => {
    props.onQuickSelectionChange(selectedFilterId);
  };

  return (
    <FilterForm ref={ref} {...props} defaultValues={filter ?? {}} onQuickSelectionChange={onQuickSelectionChange} />
  );
};

export default forwardRef(FilterFormContainer);
